"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIsCurrentlyActiveProperty = exports.isCurrentlyActivePropertyDefinition = void 0;
exports.isCurrentlyActivePropertyDefinition = {
    view: { label: 'Is currently active' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'boolean',
    multiple: false,
    default: true,
    name: 'is-currently-active',
};
const isIsCurrentlyActiveProperty = (prop) => {
    return prop.name === exports.isCurrentlyActivePropertyDefinition.name;
};
exports.isIsCurrentlyActiveProperty = isIsCurrentlyActiveProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtY3VycmVudGx5LWFjdGl2ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2lzLWN1cnJlbnRseS1hY3RpdmUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxtQ0FBbUMsR0FBRztJQUNqRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUscUJBQXFCLEVBQUU7SUFDdEMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsT0FBTyxFQUFFLElBQUk7SUFDYixJQUFJLEVBQUUscUJBQXFCO0NBQ0ksQ0FBQTtBQUkxQixNQUFNLDJCQUEyQixHQUFHLENBQUMsSUFBa0IsRUFBcUMsRUFBRTtJQUNuRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9